import React, { useState } from "react";
import { t } from "i18next";

import styles from "./Geo.module.scss";

type Props = {
  geo: string | string[];
};

export const GeoItem: React.FC<{ code: string; label?: string }> = ({
  code,
  label,
}) => {
  const [hasError, setHasError] = useState(false);
  const lower = code.toLowerCase();

  if (hasError) {
    return (
      <div className={styles["geo-item"]}>
        <span className="mr-5">🌍</span>
        {label ?? t(code)}
      </div>
    );
  }

  return (
    <div className={styles["geo-item"]}>
      <img
        src={`https://flagpedia.net/data/flags/icon/16x12/${lower}.png`}
        alt={code}
        onError={() => setHasError(true)}
      />
      {label ?? t(code)}
    </div>
  );
};

export const Geo: React.FC<Props> = ({ geo }) => {
  return (
    <div className={styles["geo-row"]}>
      {Array.isArray(geo) ? (
        geo.map((g) => <GeoItem key={g} code={g} />)
      ) : (
        <GeoItem code={geo} />
      )}
    </div>
  );
};
